import LazyLoad from 'vanilla-lazyload';
import '../polyfills/vanilla-lazyload.min.js';
import {
	header,
	keyboardDetection,
	toggler,
	focusLock,
	scroller,
	videoOverlay,
	blog,
	cookieConsent,
} from '../modules';
import hotelSearch from '../modules/hotelSearch';

const common = {
	// JavaScript to be fired on all pages
	init() {
		new LazyLoad();
		header();
		keyboardDetection();
		hotelSearch();
		toggler();

		focusLock({
			elements: [document.querySelector('header')],
			sizes: [0, 767],
			controlledBy: document.querySelector('[class*=header__toggle]'),
		});

		blog();
		scroller();
		videoOverlay();
		cookieConsent();

		if (window.location.hash) {
			const element = document.querySelector(window.location.hash);
			element.scrollIntoView();
		}

		const holidexBtn = document.querySelector('.holidex-btn');

		if (holidexBtn) {
			holidexBtn.addEventListener('click', (e) => {
				const loader = document.createElement('div');
				loader.className = 'loader';
				holidexBtn.parentNode.append(loader);
				fetch('/wp-json/ihg/v1/update-holidex', {
					headers: {
						'X-WP-Nonce': holidexBtn.nextElementSibling.value,
					},
				})
					.then((response) => response.json())
					.then((json) => {
						const message = document.createElement('div');
						message.textContent = 'Success!';
						holidexBtn.parentNode.append(message);

						loader.remove();
					})
					.catch((error) => {
						const message = document.createElement('div');
						message.textContent = 'Fail! Check console.log';
						holidexBtn.parentNode.append(message);
						console.error('Error:', error);

						loader.remove();
					});
			});
		}

		const formLanguageField = document.querySelectorAll(
			'.gfield.form-language input[type="radio"]'
		);
		if (formLanguageField) {
			formLanguageField.forEach(function (language_choice) {
				if (language_choice.value == document.documentElement.lang) {
					// this is the language the user is viewing the form in
					language_choice.checked = true;
				}
			});
		}

		/**
		 * Bulk Action for Gravity Forms Entries, Add Tags.
		 */
		if (document.querySelector('.forms_page_gf_entries')) {
			const entryRows = Array.from(document.querySelectorAll('.entry_row'));
			const checkedValues = [];
			const selectAll = document.getElementById('cb-select-all-1');
			const doActionButton = document.getElementById('doaction');
			const bulkActionSelector = document.getElementById('bulk-action-selector-top');
			const getUrl = window.location;
			const homeUrl = `${getUrl.protocol}//${getUrl.host}/${getUrl.pathname.split('/')[1]}`;

			// handle selectAll checkbox
			if (selectAll) {
					selectAll.addEventListener('click', () => {
							entryRows.forEach((row) => {
									const checkbox = row.querySelector('input[type="checkbox"]');
									const value = checkbox.value; // Entry ID

									if (selectAll.checked) {
											if (!checkedValues.includes(value)) checkedValues.push(value);
											checkbox.checked = true;
									} else {
											const index = checkedValues.indexOf(value);
											if (index > -1) checkedValues.splice(index, 1);
											checkbox.checked = false;
									}
							});
					});
			}

			// handle individual checkbox checks
			entryRows.forEach((row) => {
					const checkbox = row.querySelector('input[type="checkbox"]');
					const value = checkbox.value; // Entry ID

					checkbox.addEventListener('click', () => {
							if (checkbox.checked) {
									if (!checkedValues.includes(value)) checkedValues.push(value);
							} else {
									const index = checkedValues.indexOf(value);
									if (index > -1) checkedValues.splice(index, 1);
							}
					});
			});

			// Add Tags Bulk Action
			if (doActionButton) {
					doActionButton.addEventListener('click', (event) => {
							const selectedOption = bulkActionSelector.value;

							if (selectedOption === 'add_tag') {
									event.preventDefault();
									const baseUrl = `/bulk-tags?entryIds=${checkedValues.join(',')}&tags=`;
									createModal(baseUrl);
							}
					});
			}

			// Add Tags modal
			function createModal(baseUrl) {
					const overlay = document.querySelector('.tag-overlay');
					const modal = document.querySelector('.tag-modal');
					const closeButton = modal.querySelector('.tag-modal__close');
					const submitButton = document.getElementById('tag-modal-submit');
					const tagsInput = document.getElementById('tag-input');

					// show modal
					overlay.classList.add('show');
					modal.classList.add('show');

					// hide modal
					closeButton.addEventListener('click', () => {
							overlay.classList.remove('show');
							modal.classList.remove('show');
					});

					// update submit button URL dynamically
					tagsInput.addEventListener('input', (event) => {
							const tagsValue = event.target.value;
							submitButton.href = `${homeUrl}${baseUrl}${tagsValue}`;
					});
			}
		}
	},

	// JavaScript to be fired on all pages, after page specific JS is fired
	finalize() {},
};

export default common;



// WEBPACK FOOTER //
// ./scripts/routes/common.js